import React from 'react'
import { StatusCategory } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import Tag, {
  TAG_TYPE_DANGER,
  TAG_TYPE_DANGER_OUTLINE,
  TAG_TYPE_NEUTRAL,
  TAG_TYPE_SUCCESS_OUTLINE,
  TAG_TYPE_WARNING,
} from '@divvy-web/skylab.tag'

export const formatDate = (date) => (
  <FormattedMessage
    defaultMessage='{date, date, medium}'
    id='sputnik.utils__uS1Y/d'
    values={{ date: new Date(date) }}
  />
)

export const getDashboardStatusTagProps = (status: StatusCategory): React.ComponentProps<typeof Tag> => {
  switch (status) {
    case StatusCategory.IN_REVIEW:
      return {
        type: TAG_TYPE_NEUTRAL,
        children: (
          <FormattedMessage
            defaultMessage='In review'
            id='sputnik.utils__plemGH'
          />
        ),
      }
    case StatusCategory.INCOMPLETE:
      return {
        children: (
          <FormattedMessage
            defaultMessage='Incomplete'
            id='sputnik.utils__kHwKVg'
          />
        ),
      }
    case StatusCategory.EXPIRES:
      return {
        type: TAG_TYPE_DANGER,
        children: (
          <FormattedMessage
            defaultMessage='Expired'
            id='sputnik.utils__RahCRH'
          />
        ),
      }
    case StatusCategory.ACTION_NEEDED:
      return {
        type: TAG_TYPE_WARNING,
        children: (
          <FormattedMessage
            defaultMessage='Action needed'
            id='sputnik.utils__7V6vuD'
          />
        ),
      }
    case StatusCategory.ACCOUNT_CREATED:
      return {
        type: TAG_TYPE_SUCCESS_OUTLINE,
        children: (
          <FormattedMessage
            defaultMessage='Account created'
            id='sputnik.utils__FRBgoF'
          />
        ),
      }
    case StatusCategory.DECLINED:
      return {
        type: TAG_TYPE_DANGER_OUTLINE,
        children: (
          <FormattedMessage
            defaultMessage='Declined'
            id='sputnik.utils__uRYIb9'
          />
        ),
      }
    default:
      return {}
  }
}
